import { CiStar } from "react-icons/ci";
import { FaAngleRight } from "react-icons/fa6";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import { useAppDispatch } from "../../../utils/hooks";
import TextTranslate from "../../../utils/TextTranslate";
import { useStarMessageList } from "../../../store/api/useStarMessageList";

export default function StarMessageTab() {
  const dispatch = useAppDispatch();
  const { data: starMessageListData } = useStarMessageList();
  return (
    <div
      onClick={() => {
        dispatch(updateViewState({ showStarMessageList: true }));
      }}
      className="flex cursor-pointer items-center justify-between overflow-hidden rounded-2xl bg-primary px-4 py-3.5 shadow-sm ring-1 ring-black/[0.04] active:bg-black/[0.04] dark:ring-white/[0.06] dark:active:bg-white/[0.06]"
    >
      <div className="flex min-w-0 items-center gap-3 text-[15px]">
        <CiStar className="h-5 w-5 shrink-0 text-themeColor" />
        <div className="truncate text-darkText">
          <TextTranslate text="Starred Messages" />
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1 text-[15px] text-lightText">
        <span className="min-w-[1.25rem] text-right tabular-nums">
          {starMessageListData?.data?.Records?.length ?? 0}
        </span>
        <FaAngleRight className="h-3.5 w-3.5 shrink-0 opacity-50" />
      </div>
    </div>
  );
}
